import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { AccountSubpageShell } from '@/components/layout';
import { InviteCode } from '@/components/profile';
import { useCurrentUser } from '@/contexts';
import { userService } from '@/services';

export function ReferralPage() {
  const navigate = useNavigate();
  const { currentUser: profile } = useCurrentUser();
  const [invite, setInvite] = useState<{ code: string; used: number; total: number } | null>(null);

  useEffect(() => {
    if (!profile) return;
    const unsubscribe = userService.subscribeToUserInviteCode(profile.uid, setInvite);
    return () => unsubscribe();
  }, [profile]);

  if (!profile) return null;

  return (
    <AccountSubpageShell onBack={() => navigate('/account')}>
      {invite && <InviteCode code={invite.code} used={invite.used} total={invite.total} />}
    </AccountSubpageShell>
  );
}
